// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  groupRunId: __t.u64().primaryKey().name("group_run_id"),
  orientationId: __t.string().name("orientation_id"),
  orientationName: __t.string().name("orientation_name"),
  cohortName: __t.string().name("cohort_name"),
});
